var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1723717681585,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2686,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453.333333 160a97.792 97.792 0 0 1 97.792 97.792v528a97.792 97.792 0 0 1-97.792 97.749333H160a97.792 97.792 0 0 1-97.792-97.749333V257.792A97.792 97.792 0 0 1 160 160h293.333333zM394.666667 658.688H238.208a29.312 29.312 0 1 0 0 58.624H394.666667a29.312 29.312 0 1 0 0-58.666667z",
    fill: "#44b0e9",
    "p-id": 2687
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M855.125333 384a97.792 97.792 0 0 1 97.749334 97.792v293.333333a97.792 97.792 0 0 1-97.749334 97.749334H640V384h215.125333z",
    fill: "#44b0e9",
    "p-id": 2688
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.4912e6915c32655c54e72384bbb01725.svg";
export { ForwardRef as ReactComponent };